import React from 'react';

import './Navbar.scss';

import logo from './../../assets/logo.webp';

import { NavLink } from 'react-router-dom';

import { useTranslation } from 'react-i18next';


const Navbar = () => {

    const { t, i18n } = useTranslation();


    // =========================
    // CHANGE LANGUAGE
    // =========================

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        localStorage.setItem('language', language);
    };


    // =========================
    // NAVBAR ITEMS
    // =========================

    const navbarItems = [
        {
            name: t('navbar.home'),
            path: '/',
        },
        {
            name: t('navbar.about'),
            path: '/about',
        },
        {
            name: t('navbar.services'),
            path: '/singleservice',
        },
        {
            name: t('navbar.contact'),
            path: '/contact',
        },
        {
            name: t('navbar.faq'),
            path: '/Faq',
        }
    ];


    return (

        <div className="main-nav">

            <div className="container">

                <nav className="navbar navbar-expand-lg">

                    <div className="container-fluid">


                        {/* Logo */}

                        <NavLink
                            className="navbar-brand"
                            to="/"
                        >
                            <img
                                src={logo}
                                alt="logo"
                            />
                        </NavLink>


                        {/* Mobile button */}

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>


                        <div
                            className="collapse navbar-collapse"
                            id="navbarSupportedContent"
                        >


                            {/* Navbar Links */}

                            <ul className="navbar-nav m-auto mb-2 mb-lg-0">

                                {navbarItems.map((navSingle) => (

                                    <li
                                        className="nav-item"
                                        key={navSingle.path}
                                    >

                                        <NavLink
                                            className={({ isActive }) =>
                                                `nav-link ${
                                                    isActive ? 'active' : ''
                                                }`
                                            }
                                            to={navSingle.path}
                                            end={navSingle.path === '/'}
                                        >

                                            {navSingle.name}

                                        </NavLink>

                                    </li>

                                ))}

                            </ul>


                            {/* Appointment Button */}

                            <div className="theme-btn">

                                <NavLink to="/contact">
                                    {t('navbar.appointment')}
                                </NavLink>

                            </div>


                            {/* Language Switcher */}

                            <div className="language-switcher">

                                <button
                                    className={
                                        i18n.language === 'de'
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => changeLanguage('de')}
                                >
                                    DE
                                </button>


                                <span>|</span>


                                <button
                                    className={
                                        i18n.language === 'en'
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => changeLanguage('en')}
                                >
                                    EN
                                </button>


                                <span>|</span>


                                <button
                                    className={
                                        i18n.language === 'ru'
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => changeLanguage('ru')}
                                >
                                    RU
                                </button>

                            </div>


                        </div>

                    </div>

                </nav>

            </div>

        </div>

    );
};


export default Navbar;